import { render } from "./GeraetInFach.vue?vue&type=template&id=154ce4de&scoped=true"
import script from "./GeraetInFach.vue?vue&type=script&lang=js"
export * from "./GeraetInFach.vue?vue&type=script&lang=js"

import "./GeraetInFach.vue?vue&type=style&index=0&id=154ce4de&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-154ce4de"]])

export default __exports__